import script from "./ShopList.vue?vue&type=script&lang=ts&setup=true&name=ShopList"
export * from "./ShopList.vue?vue&type=script&lang=ts&setup=true&name=ShopList"

import "./ShopList.vue?vue&type=style&index=0&id=cbf62890&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbf62890"]])

export default __exports__